import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/** URL-driven prospect drawer: ?prospect=<id> is the source of truth — linkable,
 *  survives refresh, closes on browser Back. */
export function useProspect() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("prospect");

  const openProspect = useCallback(
    (accountId: number | string) => {
      setParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          p.set("prospect", String(accountId));
          return p;
        },
        { replace: false }
      );
    },
    [setParams]
  );

  const closeProspect = useCallback(() => {
    setParams(
      (prev) => {
        const p = new URLSearchParams(prev);
        p.delete("prospect");
        return p;
      },
      { replace: false }
    );
  }, [setParams]);

  return { id: raw ? Number(raw) : null, openProspect, closeProspect };
}
